import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'up-count-incorrect',
  templateUrl: './count-incorrect.component.html',
  styleUrls: ['./count-incorrect.component.scss']
})
export class CountIncorrectComponent implements OnChanges {

  @Input() expectedAmount = 0;
  @Input() initialAmount = 0;
  @Output() confirmed = new EventEmitter<number>();
  @Output() cancelled = new EventEmitter<void>();

  countInput = '';
  countedAmount = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialAmount']) {
      this.setInitialAmount(this.initialAmount);
    }
  }

  get amountDifference(): number {
    return this.countedAmount - this.expectedAmount;
  }

  appendCount(num: number) {
    if (this.countInput.length < 9) {
      this.countInput += num.toString();
      this.updateCountedAmount();
    }
  }

  clearCountLastDigit() {
    if (this.countInput.length > 0) {
      this.countInput = this.countInput.slice(0, -1);
      this.updateCountedAmount();
    }
  }

  confirm() {
    this.confirmed.emit(this.countedAmount);
  }

  cancel() {
    this.cancelled.emit();
  }

  private updateCountedAmount() {
    if (this.countInput) {
      const cents = parseInt(this.countInput, 10);
      this.countedAmount = cents / 100;
    } else {
      this.countedAmount = 0;
    }
  }

  private setInitialAmount(amount: number) {
    if (amount > 0) {
      const cents = Math.round(amount * 100);
      this.countInput = cents.toString();
      this.countedAmount = cents / 100;
    } else {
      this.countInput = '';
      this.countedAmount = 0;
    }
  }
}

